import { apiService } from '.';
import { ILoginUser, IRegisterUser } from '../shared/types/auth';

export const asyncAuthRegister = async (formAuthRegister: IRegisterUser) => {
    return await apiService.post('/api/auth/register', formAuthRegister);
};

export const asyncAuthLogin = async (formAuthLogin: ILoginUser) => {
    return await apiService.post('/api/auth/login', formAuthLogin);
};
